import { Injectable, inject } from "@angular/core";
import {catchError, map} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {ESharedFileType} from "@shared/components/files/enums/file-types.enums";
import {ESharedFileExtension} from "@shared/services/file/enums/shared-file-extension.enum";

@Injectable({
  providedIn: 'root'
})
export class SharedFileService {
  private _http = inject(HttpClient);


  readonly MimeTypeMap: { [key: string]: ESharedFileType } = {
    'image/png': ESharedFileType.IMAGE,
    'image/jpg': ESharedFileType.IMAGE,
    'image/jpeg': ESharedFileType.IMAGE,
    'application/pdf': ESharedFileType.PDF
  };

  /**
   * @name get
   * @description
   * request the blob file from param
   * @memberof SharedFileService
   * @param path
   */
  get(path: string): Observable<Blob> {
    return this._http.get(path, { responseType: "blob" }).pipe(
      map(blob => blob),
      catchError((error) => throwError(() => error))
    )
  }

  getFileExtension(fileName: string): ESharedFileExtension | null {
    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1 || lastDotIndex === fileName.length - 1) return null;

    const ext = fileName.substring(lastDotIndex + 1).toLowerCase();

    if (Object.values(ESharedFileExtension).includes(ext as ESharedFileExtension)) {
      return ext as ESharedFileExtension;
    }

    return null;
  }

  getFileTypeByExtension(name: string): 'image' | 'pdf' | 'unknown' {
    const extension = this.getFileExtension(name);
    if (!extension) return 'unknown';

    const imageExtensions = [
      ESharedFileExtension.PNG,
      ESharedFileExtension.JPG,
      ESharedFileExtension.JPEG,
    ];

    if (imageExtensions.includes(extension)) return 'image';
    if (extension === ESharedFileExtension.PDF) return 'pdf';

    return 'unknown';
  }

  getFileType(mimeType: string): ESharedFileType {
    return this.MimeTypeMap[mimeType] || ESharedFileType.UNKNOWN;
  }
}
